import { AodRule } from '@app/modules/audit/modules/aod/aod.types';
import { useAuditReportsDeleteAodRulesById } from '@mi-front/api-v2';
import { useRouter } from '@mi-front/core';
import { useToast } from '@app/core/notifications';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { aodRoutes } from '../../../routing/routes';

interface AodRuleDeleteButtonProps {
  rule: AodRule;
}

export function AodRuleDeleteButton({ rule }: AodRuleDeleteButtonProps) {
  const { formatMessage } = useIntl();
  const { history } = useRouter();
  const { notifySuccess, notifyError } = useToast();
  const [open, setOpen] = useState(false);

  const deleteMutation = useAuditReportsDeleteAodRulesById();

  const handleDelete = async () => {
    try {
      await deleteMutation.mutateAsync({ id: rule.id });

      notifySuccess(
        formatMessage({
          id: 'audit.aod.rules.notifications.deleted',
          defaultMessage: 'Regla AOD eliminada',
        }),
      );

      history.push(aodRoutes.rules.gen());
    } catch (error) {
      notifyError(
        formatMessage({
          id: 'audit.aod.rules.notifications.deleteError',
          defaultMessage: 'Error al eliminar la regla AOD',
        }),
      );
      console.error('Error deleting AOD Rule:', error);
    }
  };

  return (
    <>
      <Button
        size="small"
        variant="outlined"
        color="error"
        startIcon={<DeleteIcon />}
        onClick={() => setOpen(true)}
      >
        {formatMessage({
          id: 'common.actions.delete',
          defaultMessage: 'Eliminar',
        })}
      </Button>

      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          {formatMessage({
            id: 'audit.aod.rules.delete.title',
            defaultMessage: 'Eliminar regla AOD',
          })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {formatMessage(
              {
                id: 'audit.aod.rules.delete.message',
                defaultMessage:
                  '¿Estás seguro de que quieres eliminar la regla "{name}"? Esta acción no se puede deshacer.',
              },
              { name: rule.name },
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} disabled={deleteMutation.isPending}>
            {formatMessage({
              id: 'common.actions.cancel',
              defaultMessage: 'Cancelar',
            })}
          </Button>
          <Button
            onClick={handleDelete}
            loading={deleteMutation.isPending}
            color="error"
            variant="contained"
          >
            {formatMessage({
              id: 'common.actions.delete',
              defaultMessage: 'Eliminar',
            })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
